/** @jsxImportSource @emotion/react */
import React, { useContext } from 'react';
import ActionButton from '../../common/components/ActionButton/ActionButton';
import { OrderContext } from '../../common/providers/ContextProvider';
import { ThemeContext } from '../../config/theme';
import themedStyles from './OrderFooter.css';

interface Props {
  display: boolean;
  enableAdvance: boolean;
  placeOrder: () => void;
}

export default function OrderFooter({ display, enableAdvance, placeOrder }: Props) {
  const { isLastStep, getOrderPrice, advanceOrderStep } = useContext(OrderContext);

  const styling = themedStyles(useContext(ThemeContext));
  const footerStyle = display
    ? [styling.orderFooter, styling.show]
    : [styling.orderFooter, styling.hidden];

  const callback = !isLastStep() ? advanceOrderStep : placeOrder;
  const buttonText = !isLastStep() ? 'NESTE' : 'LEGG I HANDLEKURV';
  return (
    <div css={footerStyle}>
      <div css={styling.totalContainer}>
        <span>Total</span>
        <span css={styling.total}> {getOrderPrice() / 100 + ',00 kr'}</span>
      </div>
      {enableAdvance && <ActionButton onClick={callback} text={buttonText} />}
    </div>
  );
}
